import styled from 'styled-components';
import FullWidth from '@grnhse/seedling/lib/birch/layouts/full_width';
import { FullPalette } from '@grnhse/seedling/lib/birch/colors';

const NoOverflowFullWidth = styled(FullWidth)`
  overflow: hidden;
  background-color: ${FullPalette.WHITE};
  z-index: 1;
  padding-top: 8px;

  .MuiDataGrid-cell,
  .MuiDataGrid-cellCheckbox {
    align-items: flex-start;
    padding-top: 4px;
  }

  .MuiDataGrid-cellCheckbox.MuiDataGrid-cell {
    padding-top: 14px;
  }

  .MuiDataGrid-row {
    .candidate-bookmark {
      height: 0;

      &.hide {
        display: none;
      }
    }

    &:hover {
      .candidate-full-name {
        text-decoration: underline;
      }

      .candidate-bookmark.hide {
        display: flex;
      }
    }
  }
`;

export default NoOverflowFullWidth;
